export const gameLOLTestSet: string[] = [
  "롤 챔피언 이름",
  "롤 챔피언의 스킬 이름",
  "수영장 파티 스킨이 있는 롤 챔피언 이름",
  "남성 롤 챔피언 이름",
  "여성 롤 챔피언 이름",
  "인간이 아닌 롤 챔피언 이름",
  "역대 롤드컵 우승팀",
]